import { Plus } from 'lucide-react'

function AlbumsPage() {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Albums</h1>
        <button className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary/90 text-primary-foreground rounded-md transition-colors">
          <Plus size={18} />
          New Album
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {/* Placeholder album cards */}
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-card border border-border rounded-lg overflow-hidden hover:border-primary/50 transition-colors cursor-pointer"
          >
            <div className="aspect-square bg-secondary flex items-center justify-center">
              <span className="text-muted-foreground">Cover Image</span>
            </div>
            <div className="p-3">
              <h3 className="font-medium truncate">Album {i}</h3>
              <p className="text-sm text-muted-foreground">0 photos</p>
            </div>
          </div>
        ))}

        {/* Create New Album Card */}
        <div className="bg-card border border-dashed border-border rounded-lg overflow-hidden hover:border-primary/50 transition-colors cursor-pointer">
          <div className="aspect-square flex flex-col items-center justify-center gap-2 text-muted-foreground hover:text-foreground">
            <Plus size={32} />
            <span className="text-sm">Create New</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlbumsPage
